import axiosNew from '../../helpers/axios'

const MIGRATION_BASE = 'support/storyMap/migration'

const formatMigrationMessage = (error, fallback) =>
    error?.response?.data?.message ??
    error?.response?.data?.error ??
    error?.message ??
    fallback

export const listStoryMapMigrationSourceProjects = async ({ search = '' } = {}) => {
    try {
        const params = new URLSearchParams()
        const trimmed = String(search ?? '').trim()
        if (trimmed) params.set('search', trimmed)

        const query = params.toString()
        const response = await axiosNew({
            url: query
                ? `${MIGRATION_BASE}/source-projects?${query}`
                : `${MIGRATION_BASE}/source-projects`,
            method: 'get',
        })

        const payload = response?.data ?? {}

        return {
            success: payload.success ?? true,
            message: payload.message,
            total: payload.total ?? (payload.data?.length ?? 0),
            data: payload.data ?? [],
        }
    } catch (error) {
        return {
            success: false,
            message: formatMigrationMessage(
                error,
                'Failed to load source story map projects'
            ),
            code: error?.response?.data?.code,
            total: 0,
            data: [],
        }
    }
}

export const listStoryMapMigrationTargetProjects = async ({ search = '' } = {}) => {
    try {
        const params = new URLSearchParams()
        const trimmed = String(search ?? '').trim()
        if (trimmed) params.set('search', trimmed)

        const query = params.toString()
        const response = await axiosNew({
            url: query
                ? `${MIGRATION_BASE}/target-projects?${query}`
                : `${MIGRATION_BASE}/target-projects`,
            method: 'get',
        })

        const payload = response?.data ?? {}

        return {
            success: payload.success ?? true,
            message: payload.message,
            total: payload.total ?? (payload.data?.length ?? 0),
            data: payload.data ?? [],
        }
    } catch (error) {
        return {
            success: false,
            message: formatMigrationMessage(
                error,
                'Failed to load PMS target projects'
            ),
            code: error?.response?.data?.code,
            total: 0,
            data: [],
        }
    }
}

export const runStoryMapMigration = async ({
    sourceStoryMapProjectId,
    targetPmsProjectId,
    dryRun = false,
} = {}) => {
    try {
        const response = await axiosNew({
            url: `${MIGRATION_BASE}/move`,
            method: 'post',
            data: {
                sourceStoryMapProjectId,
                targetPmsProjectId,
                dryRun: Boolean(dryRun),
            },
        })

        const payload = response?.data ?? {}

        return {
            success: payload.success ?? Boolean(payload.result),
            message: payload.message,
            code: payload.code,
            result: payload.result ?? null,
        }
    } catch (error) {
        return {
            success: false,
            message: formatMigrationMessage(error, 'Story map migration failed'),
            code: error?.response?.data?.code,
            result: null,
        }
    }
}

export const getStoryMapMigrationStatus = async ({
    sourceStoryMapProjectId,
    targetPmsProjectId,
} = {}) => {
    try {
        const params = new URLSearchParams({
            sourceStoryMapProjectId: String(sourceStoryMapProjectId),
        })

        if (targetPmsProjectId) {
            params.set('targetPmsProjectId', String(targetPmsProjectId))
        }

        const response = await axiosNew({
            url: `${MIGRATION_BASE}/status?${params.toString()}`,
            method: 'get',
        })

        const payload = response?.data ?? {}

        return {
            success: payload.success ?? Boolean(payload.result),
            message: payload.message,
            code: payload.code,
            result: payload.result ?? null,
        }
    } catch (error) {
        return {
            success: false,
            message: formatMigrationMessage(
                error,
                'Failed to fetch migration status'
            ),
            code: error?.response?.data?.code,
            result: null,
        }
    }
}
